import {AnyAction, DeepPartial, StoreCreator} from "redux";
import {IApplicationState} from "../index";

const MAX_AGE = 50;

interface StateFlowEnhancerOptions {
    maxAge: number;
}

const flow: { action: AnyAction; state: DeepPartial<IApplicationState> }[] = [];

export function exportStateFlow() {
    try {
        return {
            payload: JSON.stringify(flow.map(step => step.action)),
            preloadedState: JSON.stringify(flow[0]?.state || {})
        }
    }
    catch (e) {
        return {
            error: `<<${e.message}>>`
        };
    }
}

export default function stateFlowEnhancer<StoreExt, StateExt>(enhancerOptions?: Partial<StateFlowEnhancerOptions>) {
    const options = {
        ...enhancerOptions,
        maxAge: MAX_AGE
    };

    return (createStore: StoreCreator) => {
        return (reducer: any, initialState: any, enhancer: any) => {
            const store = createStore(reducer, initialState, enhancer);

            const dispatch = (action: AnyAction) => {
                const state = store.getState() as DeepPartial<IApplicationState>;
                const result = store.dispatch(action);

                flow.push({
                    action: action,
                    state: state
                });

                if (flow.length > options.maxAge) {
                    flow.shift();
                }

                return result;
            };

            return {
                ...store,
                dispatch
            };
        };
    };
}